import {createStructuredSelector} from 'reselect';
import {bindActionCreators} from 'redux';

import {
  isDesignNameInHeaderEnabled,
  isMultiItemEligible,
  isSleeveDecoEligible
} from '~/selectors/ConfigSelectors';
import {
  anchorColorCount,
  getCurrentSelectionIndex,
  getProductsData,
  getSelectedProduct,
  getSelectedProductColor,
  getSelectedProductItemPrice,
  getSelectedProductName,
  getSelectedProducts,
  isSelectedMultiItemEnabled
} from '~/selectors/ProductSelectors';
import {getTotalQuantity} from '~/selectors/QuoteSelectors';
import {attemptFireNoSleeveImagesTag} from '~/actions/AnalyticsActions';
import {autoSave} from '~/actions/DesignActions';
import {getOrderOptionsPath} from '~/slices/pathSlice';
import {deleteProduct, selectProduct} from '~/actions/ProductActions';
import {selectCartItemsCount} from '~/api/designs/cartApi';
import {
  addCurrentDesignToCart,
  selectIsCurrentDesignInCart
} from '~/slices/cartSlice';

export const select = () =>
  createStructuredSelector({
    cartItemCount: selectCartItemsCount,
    currentSelectionIndex: getCurrentSelectionIndex,
    isCurrentDesignInCart: selectIsCurrentDesignInCart,
    isMultiItemEligible,
    isSleeveDecoEligible,
    itemPrice: getSelectedProductItemPrice,
    items: getProductsData,
    orderOptionsPath: getOrderOptionsPath,
    product: getSelectedProduct,
    productName: getSelectedProductName,
    productColor: getSelectedProductColor,
    productColorCount: anchorColorCount,
    multiItemEnabled: isSelectedMultiItemEnabled,
    selectedProducts: getSelectedProducts,
    totalQuantities: getTotalQuantity,
    isDesignNameInHeaderEnabled
  });

export function actions(dispatch) {
  return {
    ...bindActionCreators(
      {
        addCurrentDesignToCart,
        attemptFireNoSleeveImagesTag,
        onSelectProductClick: selectProduct,
        onDeleteProductClick: deleteProduct,
        saveDesign: autoSave
      },
      dispatch
    )
  };
}
